import React, { useState } from 'react';
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import InfoSection from "../components/InfoSection";
import { homeObjSeven } from '../components/InfoSection/Data';
import SizingGuidelines from '../components/SizingGuidelines';

const Sizing_guidelines = () => {
    
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <Sidebar isOpen={isOpen} toggle={toggle} type={false}/>
            <Navbar toggle={toggle} margin={true} type={false} lightTheme={true}/>
            <InfoSection {...homeObjSeven}/>
            <SizingGuidelines />
            <Footer/>
        </>
    )
}

export default Sizing_guidelines;
